import { render, staticRenderFns } from "./ModalProfile.vue?vue&type=template&id=245a9c3c"
import script from "./ModalProfile.vue?vue&type=script&lang=js"
export * from "./ModalProfile.vue?vue&type=script&lang=js"
import style0 from "./ModalProfile.vue?vue&type=style&index=0&id=245a9c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports